import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import * as z from "zod/v4";

export const examplePopulatedLiquidTemplate = {
  name: "examplePopulatedLiquidTemplate" as const,
  input: z.object({
    schemaType: z.nativeEnum(SchemaType),
    template: z.string(),
  }),
  output: z.discriminatedUnion("success", [
    z.object({ success: z.literal(true), template: z.string() }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
